import { render, staticRenderFns } from "./TextHandlingCell.vue?vue&type=template&id=081e94c4&scoped=true"
import script from "./TextHandlingCell.vue?vue&type=script&lang=js"
export * from "./TextHandlingCell.vue?vue&type=script&lang=js"
import style0 from "./TextHandlingCell.vue?vue&type=style&index=0&id=081e94c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e94c4",
  null
  
)

export default component.exports